import React from 'react';
import { styled } from 'dripsy';
import { observer } from 'mobx-react-lite';
import { View } from 'react-native';

import { Separator } from '../common/Separator';
import { BaseText } from '../common/BaseText';
import { Touchable } from '../common/Touchable';
import { TutorialTimestamp } from '@models/Tutorials/TutorialTimestampModel';

const TouchableContainer = styled(Touchable)({
  flex: 1,
});

const Title = styled(BaseText)({
  color: '$heading800',
  fontWeight: 'semi',
  variant: 'text.small',
});

const TimeContainer = styled(View)({
  py: '$2',
  px: '$4',
  bg: '$primary100',
  borderRadius: 8,
});

const Time = styled(BaseText)({
  color: '$text400',
  variant: 'text.xxsmall',
});

export interface ITimestampItemProps {
  item: TutorialTimestamp;
  onPress(item: TutorialTimestamp): void;
}

export const TimestampItem = observer<ITimestampItemProps>(
  ({ item, onPress }) => {
    return (
      <TouchableContainer onPress={() => onPress(item)}>
        <Title>{item.text}</Title>
        <Separator size="$2" />
        <BaseText>
          <TimeContainer>
            <Time>{item.formattedTime}</Time>
          </TimeContainer>
        </BaseText>
      </TouchableContainer>
    );
  },
);
